var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: _vm.context.classes.element,
      attrs: { "data-type": _vm.context.type }
    },
    [
      _c(
        "FormulateSlot",
        { attrs: { name: "prefix", context: _vm.context } },
        [
          _vm.context.slotComponents.prefix
            ? _c(_vm.context.slotComponents.prefix, {
                tag: "component",
                attrs: { context: _vm.context }
              })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "button",
        _vm._g(
          _vm._b(
            { attrs: { type: _vm.type } },
            "button",
            _vm.attributes,
            false
          ),
          _vm.$listeners
        ),
        [
          _vm._t(
            "default",
            function() {
              return [
                _c(_vm.context.slotComponents.buttonContent, {
                  tag: "component",
                  attrs: { context: _vm.context }
                })
              ]
            },
            { context: _vm.context }
          )
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "FormulateSlot",
        { attrs: { name: "suffix", context: _vm.context } },
        [
          _vm.context.slotComponents.suffix
            ? _c(_vm.context.slotComponents.suffix, {
                tag: "component",
                attrs: { context: _vm.context }
              })
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }